import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    siteUrl: 'https://tdc-test.giant.com.cn',
    api: {//api链接
      gra_api: 'https://tdc-gw-test.giant.com.cn/api.php/',//接口
      gra_admin_api: 'https://tdc-gw-test.giant.com.cn/admin.php', //后台接口
      login_api: 'https://sso-test.giant.com.cn/xxl-sso-server/sso', //单点登录接口
      gateway_api: 'https://gateway-test.giant.com.cn/giantService', //gateway接口
      org_api: 'https://org-api-test.giant.com.cn/api', //组织中台接口
      
    },
    externalurl: {//外部链接
      // giant_url: 'https://u-api-test.giant.com.cn/index.php',
      opo: 'https://opo-test.giant.com.cn/opo-web/#/',
      giant_url: 'https://u-api-test.giant.com.cn/index.php'
    },

    DLINE_ENVIRONMENT: '测试环境',//
    SHOW_DOWNLOAD: true,
    IS_COMPUTER: true,

    theme: {
      
    },

    loginUser: {},//登录用户信息

    currentUser: {}, //当前查询信息角色属性
    keepAlivePage: [],//缓存的页面数据
    browser: (function(ua){
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;
      
      //if(vMark == "trident") vMark = "ie11";
      
      a.b=vMark;
      a.v=b.version;
      a.m=/mobile/i.test(ua);
      a.wx=/MicroMessenger/i.test(ua);
      a.wxminiprogram=/miniProgram/i.test(ua);
      a.giantapp=/giantapp/i.test(ua);
      a.giantevapp=/giantevapp/i.test(ua);
      a.giantopoapp=/giantopoapp/i.test(ua);
      a.ios=/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
      a.adnroid=/(Android)/i.test(ua);

      return a;
    })(window.navigator.userAgent.toLowerCase()),

  },
  getters: {//相当于计算属性

  },
  mutations: {//逻辑处理，同步
    updateState( state, data ){//通用修改值
      state[data.label] = data.data;
    },
    changeApi( state, n ){//改变api链接
      if( n ){
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl( state, n ){//改变外部链接
      if( n ){
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment( state, n ){//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = n;
    },
    changeIscomputer( state, n ){//正式环境撤掉“测试”标志
      state.IS_COMPUTER = n;
    },

    updateLoginUser( state, data ){//修改登录用户数据
      state.loginUser = data;
    },
    CHANGE_KEEP_ALIVE(state, data) {
        state.keepAlivePage = data
    },

  },
  actions: {//类似 mothods，异步
     // 页面缓存
    setKeepAlivePage({
        commit
    }, data) {
        commit("CHANGE_KEEP_ALIVE", data)
    },
  }
});

if( document.body.clientWidth > 640 ){
  store.commit('changeIscomputer', false);//PC端环境
}

//正式环境
if( window.location.host == 'gra.giant.com.cn' ){
  store.commit('changeApi', {
    gra_api: 'https://gra-gw.giant.com.cn/api.php/',//接口
    gra_admin_api: 'https://gra-gw.giant.com.cn/admin.php', //后台接口
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso', //单点登录接口
    gateway_api: 'https://gateway.giant.com.cn/giantService', //gateway接口
    org_api: 'https://org-api.giant.com.cn/api', //组织中台接口
  });
  store.commit('changeExternalurl', {
    // giant_url: 'https://u-api.giant.com.cn/index.php',
    giant_url: 'https://u-api.giant.com.cn/index.php',
    opo: 'https://opo.giant.com.cn/opo-web/#/',
  });
  store.commit('changeEnvironment', false);//
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://gra.giant.com.cn',
  });
} else if( window.location.host == 'gra-yu.giant.com.cn' ){//预发环境
  store.commit('changeApi', {
    gra_api: 'https://gra-gw-yu.giant.com.cn/api.php/',//接口
    gra_admin_api: 'https://gra-gw-yu.giant.com.cn/admin.php', //后台接口
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso', //单点登录接口
    gateway_api: 'https://gateway.giant.com.cn/giantService', //gateway接口
    org_api: 'https://org-api.giant.com.cn/api', //组织中台接口
  });
  store.commit('changeExternalurl', {
    // giant_url: 'https://u-api.giant.com.cn/index.php',
    giant_url: 'https://u-api.giant.com.cn/index.php',
    opo: 'https://opo-yu.giant.com.cn/opo-web/#/',
  });
  store.commit('changeEnvironment', false);//
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://gra-yu.giant.com.cn',
  });
}



//导出store
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js